export const formatName = (name:string) => {
  const firstName = name.slice(0, 1);
  return firstName + Array.from(Array(name.length - 1).keys()).map((e) => 'O').join('');
};
